const KNOWN: Record<string, string> = {
  customer: '#2563eb',
  catalogue: '#d97706',
  'checkout alpha': '#059669',
  'checkout core payments': '#7c3aed',
  platform: '#475569',
  seatmap: '#db2777',
  external: '#6b7280',
};
const FALLBACK = ['#0891b2', '#b45309', '#be123c', '#4d7c0f', '#6d28d9'];

/** A stable colour for a team. The team name is always shown too, so colour is never the only cue. */
export const teamColor = (team: string) => {
  const key = team.trim().toLowerCase();
  if (KNOWN[key]) return KNOWN[key];
  const hash = [...key].reduce((sum, ch) => sum + ch.charCodeAt(0), 0);
  return FALLBACK[hash % FALLBACK.length];
};
